module.exports = __webpack_public_path__ + "bc1b6aa260c4108dc1f4daee34230796.jpg";